import {DEFAULT_RGB} from "../../constants/config";
import Color from "./Color";

/**
 * @class PaletteColor
 */
export default class PaletteColor extends Color {
    /**
     * @param {Number}          id
     * @param {String}          name
     * @param {String}          displayName
     * @param {String}          code
     * @param {String}          rgb
     * @param {Boolean}         local
     * @param {Boolean}         hasFormula
     * @param {Number}          cifId
     * @param {Number}          fandeckId
     * @param {Array | null}    moreInfoData
     * @param {Boolean}         hasImage
     * @param {Boolean}         hasReflData
     */
    constructor(
        id,
        name,
        displayName,
        code,
        rgb = DEFAULT_RGB,
        local = false,
        hasFormula = true,
        cifId = null,
        fandeckId = null,
        moreInfoData = null,
        hasImage = false,
        hasReflData = false
    ) {
        super(id, name, displayName, code, rgb, local, hasFormula);

        this._cifId = cifId;
        this._fandeckId = fandeckId;
        this._moreInfoData = Array.isArray(moreInfoData) && moreInfoData.length > 0 ? moreInfoData : null;
        this._hasImage = hasImage;
        this._hasReflData = hasReflData;
    }

    /**
     * @return {Number | null}
     */
    get cifId() {
        return this._cifId;
    }

    /**
     * @return {Number | null}
     */
    get fandeckId() {
        return this._fandeckId;
    }

    /**
     * @param {Number} fandeckId
     */
    set fandeckId(fandeckId) {
        this._fandeckId = fandeckId;
    }

    /**
     * @return {Array | null}
     */
    get moreInfoData() {
        return this._moreInfoData;
    }

    /**
     * @param {Array | null}    moreInfoData
     */
    set moreInfoData(moreInfoData) {
        this._moreInfoData = moreInfoData;
    }

    /**
     * @return {Boolean}
     */
    get hasImage() {
        return this._hasImage;
    }

    /**
     * @param {Boolean} hasImage
     */
    set hasImage(hasImage) {
        this._hasImage = hasImage;
    }

    get hasReflData() {
        return this._hasReflData;
    }

    set hasReflData(reflData) {
        this._hasReflData = reflData;
    }

    /**
     * @return {PaletteColor}
     */
    clone = () => {
        return new PaletteColor(
            this._id,
            this._name,
            this._displayName,
            this._code,
            this._rgb,
            this._local,
            this._hasFormula,
            this._cifId,
            this._fandeckId,
            this._hasImage,
            this._moreInfoData,
            this._hasReflData
        );
    };

    /**
     * @return  {String}
     */
    getCifKey = () => {
        if (this._cifId === null) {
            return String(this._id);
        }

        return String(this._cifId);
    };
}
